(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/react/prescript.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/react/prescript.js');

svs.playerLogin = svs.playerLogin || {};
svs.playerLogin.store = svs.playerLogin.store || {};
svs.playerLogin.store.actions = svs.playerLogin.store.actions || {};
svs.playerLogin.constants = svs.playerLogin.constants || {};
svs.playerLogin.login = svs.playerLogin.login || {};
svs.playerLogin.login.components = svs.playerLogin.login.components || {};
svs.playerLogin.registrate = svs.playerLogin.registrate || {};
svs.playerLogin.registrate.components = svs.playerLogin.registrate.components || {};
svs.playerLogin.bankid = svs.playerLogin.bankid || {};
svs.playerLogin.bankid.components = svs.playerLogin.bankid.components || {};
svs.playerLogin.frejaeid = svs.playerLogin.frejaeid || {};
svs.playerLogin.frejaeid.components = svs.playerLogin.frejaeid.components || {};
svs.playerLogin.sharedComponents = svs.playerLogin.sharedComponents || {};

svs.playerLogin.logger = new svs.core.log.Logger('module:player-login');

svs.playerLogin.data = svs.playerLogin.data || {};
svs.playerLogin.data.login = svs.playerLogin.data.login || {};


 })(window);